// extracted by mini-css-extract-plugin
export default {"container":"Details_container__uPxZU","form":"Details_form__SFAT7","dualInput":"Details_dualInput__icVbB"};